import  api, { globalErrorHandler } from "../Api"

export const GET_BIRTHDAY = "GET_BIRTHDAY";
export const BI_LOADING = "BI_LOADING";


const config = {
  headers: {
      'content-type': 'application/json',
  }
};

export const GetBirthdayMembers = () => {
  
  return async dispatch => {
    dispatch({
      type: BI_LOADING
    });
    await api.get(`/BirthdayMembers`,config).then(res => 
      dispatch({
        type: GET_BIRTHDAY,
        data: res.data
        })
      ).catch(globalErrorHandler); 
  };
};
